export default {
    _prefix: "PassPercent",
    errors: {
        passPercentValue: "Should be an integer between 0 and 100.",
        passPercentEmpty: "This field is required.",
        passPercentNotAnInteger: "Enter a valid integer.",
    },
    labels: {
        passMark: "Pass Mark %",
    },
};
